'use strict';

var React = require('react');

var SvgPinUnfilledMinor = function SvgPinUnfilledMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.5 14.5h2.35l.408 2.856a.75.75 0 0 0 1.485 0l.407-2.856h2.35a2 2 0 0 0 2-2v-.5a2 2 0 0 0-1.944-2l-.609-2.738a2 2 0 0 0 1.053-1.762v-.5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v.5a2 2 0 0 0 1.053 1.762l-.609 2.739a2 2 0 0 0-1.944 1.999v.5a2 2 0 0 0 2 2Zm1.481-4.5h1.269a.75.75 0 0 1 0 1.5h-2.5v-.007l-.265.007a.5.5 0 0 0-.485.5v.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.485-.5l-1.17-.032-1.108-4.988.999-.539a.5.5 0 0 0 .264-.441v-.5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .264.441l1 .539-.783 3.52Z"
  }));
};
SvgPinUnfilledMinor.displayName = "PinUnfilledMinor";

exports.SvgPinUnfilledMinor = SvgPinUnfilledMinor;
